module.exports = __webpack_public_path__ + "static/media/doc-file.375a3cb4.svg";